//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export bankrecledgerconfig
export const EmployeeFundsReportComponentsConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/ewa/ReportsComponent",
      component: FuseLoadable({
        loader: () => import("./ReportsComponent.js")
      })
    }
  ]
  //end routes
};
